/**
 * Sync Log schemas for Google Drive sync history
 */

export interface SyncLog {
  id: string
  knowledge_base_id: string
  task_id: string
  status: SyncLogStatus
  files_created: number
  files_updated: number
  files_deleted: number
  error_message: string | null
  error_details: Record<string, unknown>
  started_at: string
  completed_at: string | null
  duration_seconds: number | null
  created_at: string
}

export type SyncLogStatus = 'running' | 'success' | 'partial' | 'error'

export interface SyncLogListResponse {
  sync_logs: SyncLog[]
  total: number
  page: number
  page_size: number
  total_pages: number
}

export interface SyncLogListParams {
  status?: SyncLogStatus
  page?: number
  page_size?: number
}

// Status configuration for UI
export const SYNC_LOG_STATUS_CONFIG: Record<
  SyncLogStatus,
  { label: string; color: string; icon: string }
> = {
  running: {
    label: 'Em andamento',
    color: 'bg-blue-500/20 text-blue-400',
    icon: 'loader',
  },
  success: {
    label: 'Sucesso',
    color: 'bg-emerald-500/20 text-emerald-400',
    icon: 'check',
  },
  partial: {
    label: 'Parcial',
    color: 'bg-amber-500/20 text-amber-400',
    icon: 'alert',
  },
  error: {
    label: 'Erro',
    color: 'bg-red-500/20 text-red-400',
    icon: 'x',
  },
}

// Helper to format duration
export function formatDuration(seconds: number | null): string {
  if (seconds === null) return '-'
  if (seconds < 60) return `${Math.round(seconds)}s`
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.round(seconds % 60)
  return `${minutes}m ${remainingSeconds}s`
}
